const professionTypeOptions = [
  {
    label: 'Salaried',
    value: 'SALARIED'
  },
  {
    label: 'SENP',
    value: 'SELF_EMPLOYED'
  },
  {
    label: 'SEP',
    value: 'SELF_EMPLOYED_PROFESSIONAL'
  }
];

const propertyTypeOptions = [
  {
    label: 'Villa',
    value: 'Villa'
  },
  {
    label: 'Plot',
    value: 'Plot'
  },
  {
    label: 'Independent house',
    value: 'Independent House'
  },
  {
    label: 'Flat',
    value: 'Flat'
  },
  {
    label: 'Apartment',
    value: 'Apartment'
  },
  {
    label: 'Commercial Property',
    value: 'Commercial Property'
  },
  {
    label: 'Residential Property',
    value: 'Residential Property'
  }
];

const propertyTypeOptionsForLAP = [
  {
    label: 'Villa',
    value: 'Villa'
  },
  {
    label: 'Plot',
    value: 'Plot'
  },
  {
    label: 'Independent house',
    value: 'Independent House'
  },
  {
    label: 'Apartment',
    value: 'Apartment'
  }
];

const IndustryTypeOptionsSEP = [
  {
    label: 'CA/CS/ICWAI',
    value: 'CA/CS/ICWAI'
  },
  {
    label: 'Doctor',
    value: 'Doctor'
  },
  {
    label: 'Architect',
    value: 'Architect'
  }
];

const TypeOfRentalIncomeOptions = [
  {
    label: 'Cash',
    value: 'Cash'
  },
  {
    label: 'Cheque',
    value: 'Cheque'
  },
  {
    label: 'Cash+Cheque',
    value: 'Cash And Cheque'
  }
];

const typeOfBusinessLoan = [
  {
    displayName: 'Business Loan',
    id: '12'
  }
];

const typeOfTwoWheelerLoan = [
  {
    displayName: '2 Wheeler Loan',
    id: '14'
  }
];

export {
  professionTypeOptions,
  propertyTypeOptions,
  IndustryTypeOptionsSEP,
  TypeOfRentalIncomeOptions,
  typeOfTwoWheelerLoan,
  typeOfBusinessLoan,
  propertyTypeOptionsForLAP
};
